import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import enAuth from '@/locales/en/auth.json';
import zhAuth from '@/locales/zh/auth.json';
import enChat from '@/locales/en/chat.json';
import zhChat from '@/locales/zh/chat.json';
import enCommon from '@/locales/en/common.json';
import zhCommon from '@/locales/zh/common.json';
import enLanding from '@/locales/en/landing.json';
import zhLanding from '@/locales/zh/landing.json';
import enPortfolio from '@/locales/en/portfolio.json';
import zhPortfolio from '@/locales/zh/portfolio.json';
import enPersonality from '@/locales/en/personality.json';
import zhPersonality from '@/locales/zh/personality.json';
import enInfluence from '@/locales/en/influence.json';
import zhInfluence from '@/locales/zh/influence.json';
import enSocialAnalysis from '@/locales/en/social-analysis.json';
import zhSocialAnalysis from '@/locales/zh/social-analysis.json';
import enAiPublish from '@/locales/en/ai-publish.json';
import zhAiPublish from '@/locales/zh/ai-publish.json';
import enTutorial from '@/locales/en/tutorial.json';
import zhTutorial from '@/locales/zh/tutorial.json';
import enTerms from '@/locales/en/terms.json';
import zhTerms from '@/locales/zh/terms.json';
import enUsage from '@/locales/en/usage.json';
import zhUsage from '@/locales/zh/usage.json';
import enSubscription from '@/locales/en/subscription.json';
import zhSubscription from '@/locales/zh/subscription.json';
import enPayment from '@/locales/en/payment.json';
import zhPayment from '@/locales/zh/payment.json';
import enMcp from '@/locales/en/mcp.json';
import zhMcp from '@/locales/zh/mcp.json';

// Define resources
const resources = {
  en: {
    auth: enAuth,
    chat: enChat,
    common: enCommon,
    landing: enLanding,
    portfolio: enPortfolio,
    personality: enPersonality,
    influence: enInfluence,
    'social-analysis': enSocialAnalysis,
    'ai-publish': enAiPublish,
    tutorial: enTutorial,
    terms: enTerms,
    usage: enUsage,
    subscription: enSubscription,
    payment: enPayment,
    mcp: enMcp,
  },
  zh: {
    auth: zhAuth,
    chat: zhChat,
    common: zhCommon,
    landing: zhLanding,
    portfolio: zhPortfolio,
    personality: zhPersonality,
    influence: zhInfluence,
    'social-analysis': zhSocialAnalysis,
    'ai-publish': zhAiPublish,
    tutorial: zhTutorial,
    terms: zhTerms,
    usage: zhUsage,
    subscription: zhSubscription,
    payment: zhPayment,
    mcp: zhMcp,
  },
};

// Language source of truth: user preference API (applied in App.tsx after login)
// localStorage serves as cache (written by i18n.changeLanguage)
// fallbackLng 'en' used when no localStorage value exists (first visit / not logged in)
const savedLng = localStorage.getItem('i18nextLng');

i18n.use(initReactI18next).init({
  resources,
  lng: savedLng || 'en',
  fallbackLng: 'en',
  supportedLngs: ['en', 'zh'],

  interpolation: {
    escapeValue: false,
  },

  defaultNS: 'common',
  ns: [
    'auth',
    'chat',
    'common',
    'landing',
    'portfolio',
    'personality',
    'influence',
    'social-analysis',
    'ai-publish',
    'tutorial',
    'terms',
    'usage',
    'subscription',
    'payment',
    'mcp',
  ],

  debug: import.meta.env.DEV,
});

export default i18n;
